import { FaEnvelope, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa'
// import logoNacer from '../../assets/images/logo-nacer.webp'
import '../Content/index.scss'

const Footer = () => {
  var today = new Date()
  var thisYear = today.getFullYear()

  return (
    <>
      <div className="w-full max-w-[1200px] flex flex-col justify-start items-start h-full bg-transparent rounded-3xl border-[1px] border-neutral-300 font-sans p-10 gap-10 lg:gap-y-16">
        <div className="w-fit md:w-full h-full flex flex-col gap-16">
          <div className="w-full h-full flex flex-col">
            <a
              href="https://nacer-mediouni.netlify.app/projects"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              <span className="text-neutral-400 text-base font-bold">
                Projects
              </span>
            </a>
            <div className="w-6 h-[1px] mt-1 bg-[#00ffc6]"></div>
          </div>
          <div className="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-20 ">
            <a
              href="https://nacer-mediouni.netlify.app/ooredoo"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Ooredoo NextGen
            </a>
            <a
              href="https://nacermediouni.vercel.app/case-studies/tayara"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Tayara Marketplace
            </a>

            <a
              href="https://nacer-mediouni.netlify.app/fondation"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Fondation
            </a>
            <a
              href="https://www.horizon-europe.tn/"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Horizon
            </a>
            <a
              href="https://luxor.com.tn/en/"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Luxor
            </a>
            <a
              href="https://nacer-mediouni.netlify.app/almaviva"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Almaviva
            </a>
            <a
              href="https://nacer-mediouni.netlify.app/atelier"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Atelier
            </a>
            <a
              href="https://nacer-mediouni.netlify.app/paytea"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Paytea HR SaaS
            </a>
            <a
              href="https://alriadh-landing-page.netlify.app/"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Madinaty
            </a>
            <a
              href="https://le-show-de-lautomobile.vercel.app/"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Tayara Expo
            </a>
            <a
              href="https://nacer-mediouni.netlify.app/freshFxDashboard"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              FreshFx SaaS Dashboard
            </a>
            <a
              href="https://nacer-mediouni.netlify.app/biat"
              className="truncate w-fit text-base text-neutral-400 font-normal hover:text-neutral-600 hover:font-medium"
            >
              Biat Appointment SaaS
            </a>
          </div>
        </div>
        <div className="w-full h-full flex flex-col md:flex-row flex-wrap md:flex-nowrap justify-between md:items-center gap-16">
          <div className="w-full h-full flex flex-col">
            <a
              href="https://nacer-mediouni.netlify.app/about"
              className="text-neutral-400 text-base font-bold"
            >
              About
            </a>
            <div className="w-6 h-[1px] mt-1 bg-[#00ffc6]"></div>
          </div>
          <div className="w-full flex justify-center items-center gap-2">
            <div className="w-8 h-[1px] bg-neutral-200 mt-2"></div>
            <a href="https://nacermediouni.vercel.app/">
              <img
                className="logo-on-loading w-10"
                src="/images/logo-nacer.webp"
                alt="logo-nacer"
              />
            </a>
            <div className="w-8 h-[1px] bg-neutral-200 mt-2"></div>
          </div>
          <div className=" w-full h-full justify-center md:justify-end items-center flex gap-2">
            {/* <h1 className="text-neutral-400 text-base font-extrabold mr-4">
                Contact
              </h1> */}
            <a href="mailto:nacer.mediouni@gmail.com">
              <FaEnvelope size={22} className="text-neutral-600" />
            </a>
            <a
              href="https://www.linkedin.com/in/nacermediouni/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin size={22} className="text-neutral-600" />
            </a>
            <a
              href="https://github.com/Nacer-MEDIOUNI"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub size={22} className="text-neutral-600" />
            </a>
            <a
              href="https://www.instagram.com/nacermedi/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram size={22} className="text-neutral-600" />
            </a>
          </div>
        </div>
      </div>
      <p className="text-neutral-600 text-sm py-8 text-center">
        Designed and built by me &copy; {thisYear} All rights reserved.
      </p>
    </>
  )
}

export default Footer
